// extracted by mini-css-extract-plugin
export default {"image":"o3-z","loaded":"p3-z"};